
<div class="strength‐meter">
	<div class="bars">
    @for( _ of [0, 1, 2, 3, 4]; let i = $index; track _) {
		<div
			class="bar"
			[class.filled]="i < filledBarCount"
		></div>
    }
	</div>
	<div class="label">
		{{ strengthLabel }}
	</div>
</div>


<div class="requirements">
	<p class="heading">Must contain at least:</p>
	<ul>
    @for(r of allRules; track r.label) {
		<li >

      @if(r.valid) {
        <lib-icon [icon]="CheckmarkFilled" [color]="'var(--alerts-success-icon-success)'"></lib-icon>
      } @else {
        <lib-icon [icon]="Checkmarkoutline" ></lib-icon>
      }
<!--			<span-->
<!--				class="icon"-->
<!--				[class.icon‐valid]="r.valid"-->
<!--				[class.icon‐invalid]="!r.valid"-->
<!--			></span>-->
			{{ r.label }}
		</li>
    }
	</ul>
</div>

